module.exports = __webpack_public_path__ + "img/tfsb2.618fdf11.png";